import { Injectable } from '@angular/core';
import {
  MatLegacyDialog as MatDialog,
  MatLegacyDialogRef as MatDialogRef,
  MatLegacyDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { WindowWrapper } from 'src/app/content-list-management/shared/wrappers/window-wrapper';
import { CmsAlertDialogComponent } from 'src/app/shared/components/cms-alert-dialog/cms-alert-dialog.component';
import {
  CmsDialogComponent,
  DialogData,
} from 'src/app/shared/components/cms-dialog/cms-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  private readonly DEFAULT_MODAL_DIMENSIONS = { maxWidth: '50%' };

  constructor(
    private dialog: MatDialog,
    public window: WindowWrapper,
    private _router: Router,
  ) {}

  openErrorDialog(
    options: Partial<DialogData>,
  ): MatLegacyDialogRef<CmsAlertDialogComponent> {
    return this.openCustomComponentDialog(CmsAlertDialogComponent, {
      title: 'Error',
      ...options,
    });
  }

  openErrorDialogAndNavigate(options: Partial<DialogData>, url: string): void {
    this.openCustomComponentDialog(CmsAlertDialogComponent, {
      title: 'Error',
      ...options,
    })
      .afterClosed()
      .subscribe((dialogResponse) => {
        if (dialogResponse) {
          this._router.navigate([url]);
        }
      });
  }

  openConcurrencyClashDialog(options: Partial<DialogData>): void {
    this.openConfirmationDialog({
      title: 'Error',
      confirmLabel: 'Reload',
      ...options,
    })
      .afterClosed()
      .subscribe((dialogResponse) => {
        if (dialogResponse) {
          this.window.location.reload();
        }
      });
  }

  openConfirmationDialog(
    options: Partial<DialogData>,
    customDimensions: object = this.DEFAULT_MODAL_DIMENSIONS,
  ): MatLegacyDialogRef<CmsDialogComponent> {
    const dialogRef = this.dialog.open(CmsDialogComponent, {
      ...customDimensions,
      data: {
        ...options,
      },
    });

    return dialogRef;
  }

  openCustomComponentDialog(
    component: any,
    inputs: object = {},
    unclosable: boolean = false,
    customDimensions: object = this.DEFAULT_MODAL_DIMENSIONS,
  ): MatDialogRef<any> {
    const dialogRef = this.dialog.open(component, {
      ...customDimensions,
      disableClose: unclosable,
      autoFocus: false,
      data: {
        ...inputs,
      },
    });

    return dialogRef;
  }
}
